// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionDataSetup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Input from 'share/components/controls/Izenda.Input';
import actions from '../Izenda.PermissionActions';
import { SECTION } from 'logic/data/Izenda.PermissionConstants';
import CheckboxAllPermission from './Izenda.CheckboxAllPermission';
import { get, isNil } from 'lodash/fp';

@connect({ toClass: true }, actions)
export default class PermissionDataSetup extends Component {
  constructor(props) {
    super(props);
    this.dataSetup = this.props.permission.dataSetup;
  }

  static propTypes = {
    permission: PropTypes.object.isRequired
  };

  render() {
    const { permissionStore, permission, localization, isTemplatePermissions, readOnly } = this.props;
    const tenantDetail = permissionStore.tenantDetail;
    const dataSetup = get('dataSetup', tenantDetail);

    return (
      (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup)) && (
        <div className={SECTION.DataSetup}>
          <GridLayout className='izenda-GridLayout-Custom'>
            <GridLayout.Row className='u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header'>
              <GridLayout.Col cols={2}>
                <a
                  className={this.props.getIconClass('isShowDataSetup')}
                  onClick={this.props.toggle.bind(this, 'isShowDataSetup')}
                />
                {localization.getText('COMMON_LABEL_DATA_SETUP')}
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
                <CheckboxAllPermission
                  permission={permission}
                  readOnly={readOnly}
                  disabled={isTemplatePermissions}
                  section={this.dataSetup}
                  tenantPermission={dataSetup}
                  tenantDetail={tenantDetail}
                />
              </GridLayout.Col>
              {permission.isTenantSetup && (
                <GridLayout.Col cols={1} className='u_textCenter'>
                  <Input
                    type='checkbox'
                    readOnly={readOnly}
                    disabled={isTemplatePermissions}
                    indeterminate={this.props.getIndeterminateCommon(this.dataSetup)}
                    checked={this.props.getCheckedCommon(this.dataSetup.tenantAccess)}
                    onChange={permission.updateTenantAccessParentDataSetup.bind(permission, this.dataSetup)}
                  />
                </GridLayout.Col>
              )}
            </GridLayout.Row>
          </GridLayout>
          {permissionStore.isShowDataSetup &&
            (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup)) && (
              <GridLayout className='izenda-GridLayout-Custom'>
                {(isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup.dataConnectors)) && (
                  <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                    <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                      {localization.getText('CONTEXT_MENU_LABEL_CONNECTION_STRING')}
                    </GridLayout.Col>
                    <GridLayout.Col cols={9}>
                      <Input
                        type='checkbox'
                        readOnly={readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.dataSetup.dataConnectors.value)}
                        onChange={permission.updateDataSetup.bind(permission, this.dataSetup.dataConnectors, 'value')}
                      />
                    </GridLayout.Col>
                    {permission.isTenantSetup && (
                      <GridLayout.Col cols={1} className='u_textCenter'>
                        <Input
                          type='checkbox'
                          readOnly={readOnly}
                          checked={this.props.getCheckedCommon(this.dataSetup.dataConnectors.tenantAccess)}
                          onChange={permission.updateTenantAccessDataSetup.bind(
                            permission,
                            this.dataSetup,
                            this.dataSetup.dataConnectors
                          )}
                        />
                      </GridLayout.Col>
                    )}
                  </GridLayout.Row>
                )}
                {(isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup.dataModel)) && (
                  <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                    <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                      {localization.getText('COMMON_LABEL_DATA_MODEL')}
                    </GridLayout.Col>
                    <GridLayout.Col cols={9}>
                      <Input
                        type='checkbox'
                        readOnly={readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.dataSetup.dataModel.value)}
                        onChange={permission.updateDataModel.bind(permission, this.dataSetup, 'value')}
                      />
                    </GridLayout.Col>
                    {permission.isTenantSetup && (
                      <GridLayout.Col cols={1} className='u_textCenter'>
                        <Input
                          type='checkbox'
                          readOnly={readOnly}
                          disabled={isTemplatePermissions}
                          checked={this.props.getCheckedCommon(this.dataSetup.dataModel.tenantAccess)}
                          onChange={permission.updateTenantAccessDataModel.bind(
                            permission,
                            this.dataSetup,
                            this.dataSetup.dataModel
                          )}
                        />
                      </GridLayout.Col>
                    )}
                  </GridLayout.Row>
                )}
                {(isNil(tenantDetail) ||
                  this.props.checkShowGroupCommon(tenantDetail.dataSetup.dataModel.customView)) &&
                  this.props.getCheckedCommon(this.dataSetup.dataModel.value) && (
                    <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                      <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubSubCategory'>
                        {localization.getText('COMMON_LABEL_CUSTOM_VIEW')}
                      </GridLayout.Col>
                      <GridLayout.Col cols={9}>
                        {(isNil(tenantDetail) || tenantDetail.dataSetup.dataModel.customView.create) && (
                          <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                            <label>
                              <Input
                                type='checkbox'
                                readOnly={readOnly}
                                disabled={isTemplatePermissions}
                                checked={this.props.getCheckedCommon(this.dataSetup.dataModel.customView.create)}
                                onChange={permission.updateDataSetup.bind(
                                  permission,
                                  this.dataSetup.dataModel.customView,
                                  'create'
                                )}
                              />
                              <span>{localization.getText('COMMON_LABEL_CREATE')}</span>
                            </label>
                          </div>
                        )}
                        {(isNil(tenantDetail) || tenantDetail.dataSetup.dataModel.customView.edit) && (
                          <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                            <label>
                              <Input
                                type='checkbox'
                                readOnly={readOnly}
                                disabled={isTemplatePermissions}
                                checked={this.props.getCheckedCommon(this.dataSetup.dataModel.customView.edit)}
                                onChange={permission.updateDataSetup.bind(
                                  permission,
                                  this.dataSetup.dataModel.customView,
                                  'edit'
                                )}
                              />
                              <span>{localization.getText('COMMON_LABEL_EDIT')}</span>
                            </label>
                          </div>
                        )}
                        {(isNil(tenantDetail) || tenantDetail.dataSetup.dataModel.customView.delete) && (
                          <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                            <label>
                              <Input
                                type='checkbox'
                                readOnly={readOnly}
                                disabled={isTemplatePermissions}
                                checked={this.props.getCheckedCommon(this.dataSetup.dataModel.customView.delete)}
                                onChange={permission.updateDataSetup.bind(
                                  permission,
                                  this.dataSetup.dataModel.customView,
                                  'delete'
                                )}
                              />
                              <span>{localization.getText('COMMON_LABEL_DELETE')}</span>
                            </label>
                          </div>
                        )}
                      </GridLayout.Col>
                      {permission.isTenantSetup && (
                        <GridLayout.Col cols={1} className='u_textCenter'>
                          <Input
                            type='checkbox'
                            readOnly={readOnly}
                            disabled={isTemplatePermissions}
                            checked={this.props.getCheckedCommon(this.dataSetup.dataModel.customView.tenantAccess)}
                            onChange={permission.updateTenantAccessCustomView.bind(
                              permission,
                              this.dataSetup,
                              this.dataSetup.dataModel.customView
                            )}
                          />
                        </GridLayout.Col>
                      )}
                    </GridLayout.Row>
                  )}

                {(isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup.advancedSettings)) && (
                  <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                    <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                      {localization.getText('PERMISSION_LABEL_ADVANCED_SETTING')}
                    </GridLayout.Col>
                    <GridLayout.Col cols={9}>
                      {(isNil(tenantDetail) || tenantDetail.dataSetup.advancedSettings.category) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.dataSetup.advancedSettings.category)}
                              onChange={permission.updateDataSetup.bind(
                                permission,
                                this.dataSetup.advancedSettings,
                                'category'
                              )}
                            />
                            <span>{localization.getText('COMMON_LABEL_CATEGORY')}</span>
                          </label>
                        </div>
                      )}
                      {(isNil(tenantDetail) || tenantDetail.dataSetup.advancedSettings.others) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.dataSetup.advancedSettings.others)}
                              onChange={permission.updateDataSetup.bind(
                                permission,
                                this.dataSetup.advancedSettings,
                                'others'
                              )}
                            />
                            <span>{localization.getText('COMMON_LABEL_OTHERS')}</span>
                          </label>
                        </div>
                      )}
                    </GridLayout.Col>
                    {permission.isTenantSetup && (
                      <GridLayout.Col cols={1} className='u_textCenter'>
                        <Input
                          type='checkbox'
                          readOnly={readOnly}
                          disabled={isTemplatePermissions}
                          checked={this.props.getCheckedCommon(this.dataSetup.advancedSettings.tenantAccess)}
                          onChange={permission.updateTenantAccessDataSetup.bind(
                            permission,
                            this.dataSetup,
                            this.dataSetup.advancedSettings
                          )}
                        />
                      </GridLayout.Col>
                    )}
                  </GridLayout.Row>
                )}
                {(isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup.import)) && (
                  <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                    <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                      {localization.getText('CONTEXT_MENU_LABEL_IMPORT')}
                    </GridLayout.Col>
                    <GridLayout.Col cols={9}>
                      <Input
                        type='checkbox'
                        readOnly={readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.dataSetup.import.value)}
                        onChange={permission.updateDataSetup.bind(permission, this.dataSetup.import, 'value')}
                      />
                    </GridLayout.Col>
                    {permission.isTenantSetup && (
                      <GridLayout.Col cols={1} className='u_textCenter'>
                        <Input
                          type='checkbox'
                          readOnly={readOnly}
                          checked={this.props.getCheckedCommon(this.dataSetup.import.tenantAccess)}
                          onChange={permission.updateTenantAccessDataSetup.bind(
                            permission,
                            this.dataSetup,
                            this.dataSetup.import
                          )}
                        />
                      </GridLayout.Col>
                    )}
                  </GridLayout.Row>
                )}
              </GridLayout>
            )}
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionDataSetup.js